'use client';

import { useCallback } from 'react';
import {
  EditorSession,
  SESSION_COOKIE,
  SESSION_TTL_MS,
  parseSession,
  serializeSession,
} from '@/lib/editor/session';

function readCookie(name: string): string | null {
  if (typeof document === 'undefined') return null;
  const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
  return match ? decodeURIComponent(match[1]) : null;
}

function writeCookie(name: string, value: string, maxAgeSeconds: number) {
  if (typeof document === 'undefined') return;
  document.cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=${maxAgeSeconds}; SameSite=Lax`;
}

export function useEditorSession() {
  const getSession = useCallback(
    (): EditorSession | null => parseSession(readCookie(SESSION_COOKIE)),
    []
  );
  const touch = useCallback((projectId: string) => {
    writeCookie(
      SESSION_COOKIE,
      serializeSession({ lastProjectId: projectId, lastActiveAt: Date.now() }),
      Math.floor(SESSION_TTL_MS / 1000)
    );
  }, []);
  const clear = useCallback(() => writeCookie(SESSION_COOKIE, '', 0), []);
  return { getSession, touch, clear };
}
